import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  
  justify-content: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 2;
`;

export const ContainerSubHeader = styled.div`
  align-items: center;
  display: flex;
  
  justify-content: center;
  width: 80%;
  margin: auto;
`;

export const ContainerCard = styled.div`
  background-image: url("./images/backGroud_orange.svg");
  border-radius: 25px;
  color: #fff;
  display: flex;
  flex-direction: column;s
  height: 80vh;
  justify-content: space-around;
  margin: 0 auto;
  padding-bottom: 10px;
  width: 70%;
`;

export const Header = styled.div`
  border-radius: 50px;
  background-color: #054d6c;
  height: 65px;
  display: flex;
  width: 80%;
  justify-content: center;
  align-items: center;
  margin: 0 auto 20px;
`;
export const BackButton = styled.button`
  background-image: url("./images/back_button.svg");
  background-position: center;
  border-radius: 50px;
  height: 57px;
  margin-left: 50px;
  width: 57px;
`;

export const ButtonRequest = styled.button`
  background-color: #00a000;
  box-shadow: 0 -2px 8px 1px rgba(0, 0, 0, 0.3);
  font-size: 22px;
  font-weight: bold;
  height: 60px;
  width: 80%;
  margin: auto;
  color: white;
  border-radius: 10px;

  &:hover {
    filter: brightness(110%);
  }
`;

export const VisitContainerScroll = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  width: 80%;
  max-height: 35%;
  overflow-y: scroll;
`;

export const VisitContainer = styled.div`
  align-items: center;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  margin: 25px 0px;
  position: relative;
  width: 100%;
`;

export const HeaderAnotherProduct = styled.h1`
  color: white;
  font-weight: 500;
  margin: auto;
`;

export const InternalVisitContainer = styled.div`
  align-items: center;
  border-radius: 50px;
  background-color: #ff9237;
  display: flex;
  height: 50px;
  justify-content: space-between;
  margin: -20px auto;
  width: 100%;
  img {
    width: 34px;
  }
  p {
    font-weight: bold;
  }
`;

export const AddContainer = styled.div`
  align-items: center;
  border-radius: 50px;
  display: flex;
  justify-content: space-between;
  width: 70px;
`;

export const Signal = styled.div`
  background-color: #ffd700;
  box-shadow: 0 0 10px 5px rgba(255, 215, 0, 0.5) ;
  border-radius: 50px;
  height: 16px;
  width: 16px;
`;

export const AddButton = styled.button`
  align-items: center;
  background-color: #366796;
  border-radius: 50px;
  color: #fff;
  display: flex;
  font-size: 30px;
  font-weight: bolder;
  height: 33px;
  justify-content: center;
  width: 33px;
`;
